<template>
  <router-link to="/signout" title="Se déconnecter" tag="div" class="menu-icon">
    <div>
      <img src="/static/images/icons/Logout.svg"/>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'header-menu-signout',
}
</script>
